// Get  Template
export const GET_ALL_TEMPLATE_REQUEST = 'GET_ALL_TEMPLATE_REQUEST';
export const GET_ALL_TEMPLATE_SUCCESS = 'GET_ALL_TEMPLATE_SUCCESS';
export const GET_ALL_TEMPLATE_FAILURE = 'GET_ALL_TEMPLATE_FAILURE';

// update params
export const UPDATE_TEMPLATE_ENTITY_PARAMS_SUCCESS =
    "UPDATE_TEMPLATE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_TEMPLATE_ENTITY_PARAMS_FAILURE =
    "UPDATE_TEMPLATE_ENTITY_PARAMS_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";